import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import reducer from './reducers';

const createCollectionPageStore = ({ collectionData, gigsData, sellersData }) =>
    createStore(reducer({ collectionData, gigsData, sellersData }), applyMiddleware(thunk));

export default createCollectionPageStore;
